import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeSelectedPriorityFilterSelector } from "~/store/selectors/selector.configOptions";
import { makeAvailablePriorityFiltersByProjectIdSelector } from "~/store/selectors/selector.tasks";

export const usePriorityFilterData = (projectId) => {
  const getSelectedPriorityFilterSelector = useMemo(makeSelectedPriorityFilterSelector, []);

  const getPriorityFiltersByProjectId = useMemo(makeAvailablePriorityFiltersByProjectIdSelector, []);

  const selected = useSelector((state) => getSelectedPriorityFilterSelector(state, projectId));

  const availablePriorityFilters = useSelector((state) => getPriorityFiltersByProjectId(state, projectId));

  const options = useMemo(() => {
    const result = [];

    availablePriorityFilters.forEach((priorityFilter) => {
      result.push({
        id: priorityFilter.id,
        name: `${priorityFilter.name}`,
        additionalInfo: `(${priorityFilter.openTasksCount}/${
          priorityFilter.completedTasksCount + priorityFilter.openTasksCount
        })`,
      });
    });

    return result;
  }, [availablePriorityFilters]);

  return [selected, options];
};
